import {takeLatest, put} from 'redux-saga/effects';
import {actions as revenueByDateReportActions} from '../slices/RevenueByDateReportSlice';
import {actions as revenueByRouteReportActions} from '../slices/RevenueByRouteReportSlice';
import {actions as revenueDetailReportActions} from '../slices/RevenueDetailReportSlice';
import {actions as revenueYieldAndRevenueActions} from '../slices/YieldAndRevenueReportSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';



function* getRevenueByDateReport({payload: {page, limit, filters}}) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statistic')}/date`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,
                
            }
        });
        yield put({type: revenueByDateReportActions.get_list_succeed.type, payload: {...response.data}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: revenueByDateReportActions.get_list_failed.type, payload: error});
    }
}

function* exportRevenueByDateReport({payload: {filters}}) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statistic')}/date`, {
            params: {
                ...filters,
                export:true
            }
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({type: revenueByDateReportActions.export_list_succeed.type});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: revenueByDateReportActions.export_list_failed.type, payload: error});
    }
}


function* exportRevenueByRouteReport({payload: {filters}}) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statistic')}/routes`, {
            params: {
                ...filters,
                export:true
            }
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({type: revenueByRouteReportActions.export_list_succeed.type});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: revenueByRouteReportActions.export_list_failed.type, payload: error});
    }
}

function* exportRevenueDetailReport({payload: {filters}}) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_reports')}/revenue-detail/export`, {
            params: {
                ...filters,
                page: filters.page ? filters.page - 1 : null
            }
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({type: revenueDetailReportActions.export_list_succeed.type});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: revenueDetailReportActions.export_list_failed.type, payload: error});
    }
}

function* exportYieldAndRevenueReport({payload: {page, limit, filters}}) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_reports')}/yield-and-revenue/export`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,
            }
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({type: revenueYieldAndRevenueActions.export_list_succeed.type});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: revenueYieldAndRevenueActions.export_list_failed.type, payload: error});
    }
}

function* getRevenueByRouteReport({payload: {page, limit, filters}}) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statistic')}/routes`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,
                
            }
        });
        yield put({type: revenueByRouteReportActions.get_list_succeed.type, payload: {...response.data}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: revenueByRouteReportActions.get_list_failed.type, payload: error});
    }
}

function* getRevenueDetailReport({payload: {page, limit, filters}}) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_reports')}/revenue-detail`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,           
            }
        });
        let newData = [...response.data.items];
        newData = newData.map((item, index) => {
            return {...item, key: index};
        });

        yield put({type: revenueDetailReportActions.get_list_succeed.type, payload: {...response.data, items: newData}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: revenueDetailReportActions.get_list_failed.type, payload: error});
    }
}

function* getYieldAndRevenueReport({payload: {filters}}) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_reports')}/yield-and-revenue`, {
            params: {
                ...filters,
                page: filters.page ? filters.page - 1 : null,             
            }
        });
        let newData = [...response.data.items];
        newData = newData.map((item, index) => {
            return {...item, key: index};
        });
        yield put({type: revenueYieldAndRevenueActions.get_list_succeed.type, payload: {...response.data, items: newData}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: revenueYieldAndRevenueActions.get_list_failed.type, payload: error});
    }
}

function* watchRequestDetail() {
    yield takeLatest(revenueByDateReportActions.get_list.type, getRevenueByDateReport);
    yield takeLatest(revenueByDateReportActions.export_list.type, exportRevenueByDateReport);
    yield takeLatest(revenueByRouteReportActions.get_list.type, getRevenueByRouteReport);
    yield takeLatest(revenueByRouteReportActions.export_list.type, exportRevenueByRouteReport);
    yield takeLatest(revenueDetailReportActions.get_list.type, getRevenueDetailReport);
    yield takeLatest(revenueDetailReportActions.export_list.type, exportRevenueDetailReport);
    yield takeLatest(revenueYieldAndRevenueActions.get_list.type, getYieldAndRevenueReport);
    yield takeLatest(revenueYieldAndRevenueActions.export_list.type, exportYieldAndRevenueReport);

}

export default watchRequestDetail;